import Hello from '../components/Test/Hello.vue'
import Index from './../components/Index/index.vue'
import Survey from './../components/Survey/index.vue'
import Reply from './../components/Survey/reply.vue'
import Clinic from '../components/Clinic/list.vue'
import Doctor from '../components/Doctor/list.vue'
import ClinicDetail from '../components/Clinic/detail.vue'

const routes = [
    {
        path: '/Hello',
        name: 'Hello',
        meta:{
            title:"这是测试页面",
        },
        component: Hello,
        beforeEnter: (to, from, next) => {
            next();
        },
    },{
        path: '/',
        name: 'Index',
        meta:{
            title:"首页",
        },
        component: Index,
        beforeEnter: (to, from, next) => {
            next();
        },
    },{
        path: '/doctor*',
        name: 'Doctor',
        meta:{
            title:"医生",
        },
        component: Doctor,
        beforeEnter: (to, from, next) => {
            next();
        },
    },{
        path: '/clinic*',
        name: 'Clinic',
        meta:{
            title:"诊所",
        },
        component: Clinic,
        beforeEnter: (to, from, next) => {
            next();
        },
    }
    ,{
        path: '/list*',
        name: 'Doctor',
        meta:{
            title:"Doctor",
        },
        component: Index,
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    {
        path: '/sso/feedback',
        name: 'feedback',
        meta:{
            title:"问题反馈",
        },
        component: Survey,
        beforeEnter: (to, from, next) => {
            next();
        }
    },
    {
        path: "/sso/feedback/reply",
        meta:{
            title:"问题反馈",
        },
        name: 'reply',
        component: Reply,
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    /*{
        path: '/doctor/:city',
        name: 'Doctor',
        meta:{
            title:"Doctor",
        },
        component: Doctor,
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    {
        path: '/doctor/:id',
        name: 'Doctor',
        meta:{
            title:"Doctor",
        },
        component: Doctor,
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    {
        path: '/doctor/:city/:id',
        name: 'Doctor',
        meta:{
            title:"Doctor",
        },
        component: Doctor,
        beforeEnter: (to, from, next) => {
            next();
        },
    },*/
    {
        path: '/:city',
        name: 'Index',
        meta:{
            title:"首页",
        },
        component: Index,
        beforeEnter: (to, from, next) => {
            next();
        },
    }
];

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js